import React from 'react'
import PanelHead from '../../../Panel/PanelHead'
import PanelBody from '../../../Panel/PanelBody'
import WhatsappGroupTable from './WhatsappGroupTable'

const WhatsappGroupList = () => {
  return (
    <div>
      <PanelHead title='Whatsapp Groups'/>
      <PanelBody content={<WhatsappGroupTable/>} />
      </div>
  )
}

export default WhatsappGroupList

